/** ----------------------------------------------------------------------------------------------------
 *  This value is used to determine in what language
 *  content should be displayed.
 *  --------------------------------------------------------------------------------------------------*/
export default {
  current: 'en',
}
